import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const BloodPressureLogPage = lazy(() => import("./BloodPressureLogPage"));

const BloodPressureLogPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <BloodPressureLogPage />
    </Suspense>
  );
};

export default BloodPressureLogPageLazy;
